import React from 'react';
import { Container, Logo, btn } from './shared';

const NAV = [
  { href: '#methode', label: 'Methode' },
  { href: '#stimmen', label: 'Erfahrungen' },
  { href: '#preis', label: 'Preis' },
  { href: '#faq', label: 'FAQ' },
];

export const Header = () => (
  <header className="sticky top-0 z-50 border-b border-white/10 bg-paper" data-testid="site-header">
    <Container className="flex h-16 items-center justify-between gap-4 sm:h-[72px]">
      <Logo />
      <nav className="hidden items-center gap-8 md:flex" aria-label="Hauptnavigation">
        {NAV.map((n) => (
          <a key={n.href} href={n.href} data-testid={`nav-${n.href.slice(1)}`}
             className="rounded text-sm font-medium text-white/75 transition-colors hover:text-white">
            {n.label}
          </a>
        ))}
      </nav>
      <a href="#bewerbung" data-testid="header-apply-btn" className={`${btn.white} shrink-0 whitespace-nowrap px-5 text-sm`}>
        Jetzt bewerben
      </a>
    </Container>
  </header>
);
